import React from "react";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const quarters = [
  // "Q1", "Q2", "Q3", "Q4"
];

const PeriodSelector = ({ period, setPeriod }) => {
  const safeperiod = period || "";

  const handleChange = (e) => {
    if (typeof setPeriod !== "function") {
      console.error("PeriodSelector: setPeriod prop is not a function");
      return;
    }
    setPeriod(e.target.value);
  };

  return (
    <div>
      <select
        id="period-select"
        value={safeperiod}
        onChange={handleChange}
        className="border border-gray-300 rounded-lg px-3 py-1 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        {/* <option value="">-- Full Year --</option>
        <option value="ytd">Year to Date</option> */}
        <optgroup label="Months">
          {months.map((m, i) => (
            <option key={i} value={`month-${i + 1}`}>
              {m}
            </option>
          ))}
        </optgroup>
        {/* <optgroup label="Quarters">
          {quarters.map((q) => (
            <option key={q} value={`quarter-${q}`}>
              {q}
            </option>
          ))}
        </optgroup> */}
      </select>
    </div>
  );
};

export default PeriodSelector;

// import React from "react";

// const months = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

// const quarters = ["Q1", "Q2", "Q3", "Q4"];

// const PeriodSelector = ({ selection, setSelection }) => {
//   // Safety fallback so selection is never undefined
//   const safeSelection = selection || { type: "year", value: null };

//   const handleChange = (e) => {
//     const value = e.target.value;

//     if (value === "") {
//       // Full year
//       setSelection({ type: "year", value: null });
//     } else if (value === "ytd") {
//       setSelection({ type: "ytd", value: true });
//     } else if (value.startsWith("month-")) {
//       setSelection({
//         type: "month",
//         value: Number(value.replace("month-", "")),
//       });
//     } else if (value.startsWith("q-")) {
//       setSelection({
//         type: "quarter",
//         value: value.replace("q-", ""), // q1, q2, q3, q4
//       });
//     }
//   };

//   return (
//     <div>
//       <label htmlFor="period-select" className="mr-2 font-semibold">
//         Select Period:
//       </label>

//       <select
//         id="period-select"
//         value={
//           safeSelection.type === "year"
//             ? ""
//             : safeSelection.type === "ytd"
//               ? "ytd"
//               : safeSelection.type === "month"
//                 ? `month-${safeSelection.value}`
//                 : safeSelection.type === "quarter"
//                   ? `q-${safeSelection.value}`
//                   : ""
//         }
//         onChange={handleChange}
//         className="border border-gray-300 rounded-lg px-3 py-1 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//       >
//         {/* Full year */}
//         <option value="">-- Full Year --</option>

//         {/* YTD */}
//         <option value="ytd">Year to Date</option>

//         {/* Months */}
//         <optgroup label="Months">
//           {months.map((m, i) => (
//             <option key={i} value={`month-${i + 1}`}>
//               {m}
//             </option>
//           ))}
//         </optgroup>

//         {/* Quarters */}
//         <optgroup label="Quarters">
//           {quarters.map((q) => (
//             <option key={q} value={`q-${q.toLowerCase()}`}>
//               {q}
//             </option>
//           ))}
//         </optgroup>
//       </select>
//     </div>
//   );
// };

// export default PeriodSelector;

// // import React from "react";

// // const months = [
// //   "January",
// //   "February",
// //   "March",
// //   "April",
// //   "May",
// //   "June",
// //   "July",
// //   "August",
// //   "September",
// //   "October",
// //   "November",
// //   "December",
// // ];
// // const quarters = ["Q1", "Q2", "Q3", "Q4"];

// // const PeriodSelector = ({ period, setPeriod }) => {
// //   /*
// //    period is a string, one of:
// //      "ytd"
// //      "month-1" ... "month-12"
// //      "quarter-q1" ... "quarter-q4"
// //   */

// //   return (
// //     <div>
// //       <label htmlFor="period-select" className="mr-2 font-semibold">
// //         Select Period:
// //       </label>
// //       <select
// //         id="period-select"
// //         value={period}
// //         onChange={(e) => setPeriod(e.target.value)}
// //         className="border border-gray-300 rounded-lg px-3 py-1 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
// //       >
// //         <option value="ytd">Year to Date</option>
// //         <optgroup label="Months">
// //           {months.map((m, i) => (
// //             <option key={`month-${i + 1}`} value={`month-${i + 1}`}>
// //               {m}
// //             </option>
// //           ))}
// //         </optgroup>
// //         <optgroup label="Quarters">
// //           {quarters.map((q) => (
// //             <option
// //               key={`quarter-${q.toLowerCase()}`}
// //               value={`quarter-${q.toLowerCase()}`}
// //             >
// //               {q}
// //             </option>
// //           ))}
// //         </optgroup>
// //       </select>
// //     </div>
// //   );
// // };

// // export default PeriodSelector;

// // // // src/components/PeriodSelector.jsx

// // // import React from "react";

// // // const quarters = ["Q1", "Q2", "Q3", "Q4"];

// // // const PeriodSelector = ({
// // //   periodType,
// // //   setPeriodType,
// // //   month,
// // //   setMonth,
// // //   quarter,
// // //   setQuarter,
// // // }) => {
// // //   return (
// // //     <div className="flex gap-6 items-center">
// // //       {/* Radio buttons to choose period type */}
// // //       <div>
// // //         <label className="mr-2 font-semibold">Period:</label>
// // //         <label className="mr-2">
// // //           <input
// // //             type="radio"
// // //             name="period"
// // //             value="month"
// // //             checked={periodType === "month"}
// // //             onChange={() => setPeriodType("month")}
// // //           />
// // //           <span className="ml-1">Month</span>
// // //         </label>
// // //         <label className="mr-2">
// // //           <input
// // //             type="radio"
// // //             name="period"
// // //             value="quarter"
// // //             checked={periodType === "quarter"}
// // //             onChange={() => setPeriodType("quarter")}
// // //           />
// // //           <span className="ml-1">Quarter</span>
// // //         </label>
// // //         <label>
// // //           <input
// // //             type="radio"
// // //             name="period"
// // //             value="ytd"
// // //             checked={periodType === "ytd"}
// // //             onChange={() => setPeriodType("ytd")}
// // //           />
// // //           <span className="ml-1">Year to Date</span>
// // //         </label>
// // //       </div>

// // //       {/* Month selector, shown only if periodType === "month" */}
// // //       {periodType === "month" && (
// // //         <select
// // //           value={month}
// // //           onChange={(e) => setMonth(Number(e.target.value))}
// // //           className="border border-gray-300 rounded-lg px-3 py-1 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
// // //         >
// // //           {[...Array(12)].map((_, i) => (
// // //             <option key={i + 1} value={i + 1}>
// // //               {new Date(0, i).toLocaleString("default", { month: "long" })}
// // //             </option>
// // //           ))}
// // //         </select>
// // //       )}

// // //       {/* Quarter selector, shown only if periodType === "quarter" */}
// // //       {periodType === "quarter" && (
// // //         <select
// // //           value={quarter}
// // //           onChange={(e) => setQuarter(e.target.value)}
// // //           className="border border-gray-300 rounded-lg px-3 py-1 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
// // //         >
// // //           {quarters.map((q) => (
// // //             <option key={q} value={q.toLowerCase()}>
// // //               {q}
// // //             </option>
// // //           ))}
// // //         </select>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default PeriodSelector;
